/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface StatusResponse {
    /** @format date-time */
    timestamp: string;
    isUp: boolean;
    assemblyVersion?: string | null;
    application?: string | null;
    environment?: string | null;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    /** @format int32 */
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions: Record<string, any>;
    [key: string]: any;
}

export interface CustomerTagsResponseDto {
    customerId?: string | null;
    tags?: string[] | null;
}

/** Response containing embed widget configuration and the embed code snippet. */
export interface EmbedConfigResponseDto {
    /** List of tenant IDs that share this embed configuration. */
    tenantIds?: string[] | null;
    /** List of allowed origins where the widget can be embedded. */
    allowedOrigins?: string[] | null;
    /**
     * Sample HTML/JavaScript embed code snippet to include on the partner's website.
     * Uses the first tenant ID in the list. Replace the data-tenant value for other tenants.
     */
    embedCode?: string | null;
    /**
     * When the config was created.
     * @format date-time
     */
    createdAt: string;
    /**
     * When the config was last updated.
     * @format date-time
     */
    updatedAt?: string | null;
    /** Whether this embed config is active. */
    isActive: boolean;
    /** The API key for authenticating widget requests. */
    apiKey?: string | null;
}

/** Request to create or update embed widget configuration. */
export interface CreateEmbedConfigRequestDto {
    /** List of tenant IDs that share this embed configuration. */
    tenantIds?: string[] | null;
    /**
     * List of allowed origins (domains) where the widget can be embedded.
     * These should be full URLs including protocol (e.g., "https://example.com").
     */
    allowedOrigins?: string[] | null;
}

export interface PrequalificationLinkDto {
    linkId?: string | null;
    linkUrl?: string | null;
    /** @format date-time */
    linkExpiration: string;
    disclaimerText?: string | null;
    /** Do not use outside of Financing team. This field may be removed at any time without warning. */
    paymentOptionsLinkUrl?: string | null;
}

export interface PrefillAddressDto {
    street?: string | null;
    unit?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

export interface PrefillDataDto {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phone?: string | null;
    address?: PrefillAddressDto | null;
}

export interface CreatePrequalificationLinkRequestDto {
    tenantId?: string | null;
    customerId?: string | null;
    /** Name of the Service Titan feature creating the link. Example: "Booking Confirmation", "Marketing Pro". */
    referrer?: string | null;
    /**
     * Optional. Set this value if you'd like the link to work for a specific financing provider.
     * If you leave this blank (recommended), the link will use the tenant's default prequalifications
     * financing provider configured in the prequalification settings.
     */
    providerName?: string | null;
    /**
     * Optional. Useful to include if you know the Business Unit ID associated with this prequalification
     * link when creating it.
     */
    buId?: string | null;
    /** Optional. Useful to include if you already know the job ID associated with this prequalification link. */
    jobId?: string | null;
    /**
     * Do not use this - internal Financing use only for a very specific use case. This field may be removed
     * at any time without warning.
     * Optional list of payment types to be saved along with this link. These payment types can be displayed to the
     * customer.
     */
    paymentTypes?: PaymentTypeDto[] | null;
    /**
     * Optional. User details to prefill the prequalification form.
     * Data is encrypted in the URL and NOT stored in the database.
     */
    prefill?: PrefillDataDto | null;
}

export interface PaymentTypeDto {
    id?: string | null;
    name?: string | null;
    method?: string | null;
    exportAsType?: string | null;
    /** @format date-time */
    modifiedOn: string;
    isHiddenFromMobile: boolean;
    autocompleteCED: boolean;
}

export interface BulkPrequalificationLinksResponseDto {
    generatedLinks?: BulkPrequalificationLinkItemDto[] | null;
    failures?: BulkPrequalificationLinkItemFailureDto[] | null;
}

export type BulkPrequalificationLinkItemDto = PrequalificationLinkDto & {
    providerName?: string | null;
    tenantId?: string | null;
    buId?: string | null;
    customerId?: string | null;
};

export interface BulkPrequalificationLinkItemFailureDto {
    providerName?: string | null;
    tenantId?: string | null;
    buId?: string | null;
    customerId?: string | null;
    errors?: ErrorInfo[] | null;
}

export interface ErrorInfo {
    errorCode?: string | null;
    description?: string | null;
    invalidParameter?: string | null;
    invalidValue?: string | null;
    failedSource: FailedStatusSource;
}

export enum FailedStatusSource {
    NotSet = 'notSet',
    Provider = 'provider',
    UserInput = 'userInput',
    Backend = 'backend',
}

export type CreateBulkPrequalificationLinksRequestDto = CreatePrequalificationLinkRequestDto[];

export interface InitialDataDto {
    prequalificationId?: string | null;
    linkUrl?: string | null;
    providerName?: string | null;
    prequalificationsToken?: string | null;
    financingToken?: string | null;
    tenantId?: string | null;
    customerId?: string | null;
    /** @format decimal */
    defaultLoanAmount: number;
    operatingStates?: string[] | null;
    defaultRepresentativeEmail?: string | null;
    paymentTypes?: PaymentTypeDto[] | null;
    prefill?: PrefillDataDto | null;
    referrer?: string | null;
}

export interface SearchPrequalificationsResponseDto {
    prequalifications?: PrequalificationDto[] | null;
    /** @format int32 */
    totalCount: number;
}

export type PrequalificationDto = PrequalificationLinkDto & {
    id?: string | null;
    providerName?: string | null;
    generalProviderName?: string | null;
    tenantId?: string | null;
    technicianId?: string | null;
    buId?: string | null;
    customerId?: string | null;
    jobId?: string | null;
    externalPrequalId?: string | null;
    referenceNumber?: string | null;
    /** @format date-time */
    createdAt?: string;
    /** @format date-time */
    updatedAt?: string;
    referrer?: string | null;
    planNumber?: string | null;
    /** @format double */
    requestedAmount?: number | null;
    /** @format double */
    approvedAmount?: number | null;
    status?: PrequalificationStatus;
    prequalifiedPlanNumbers?: string[] | null;
    /** @format date-time */
    expiresOn?: string | null;
    applicant?: ApplicantDto | null;
    paymentTypes?: PaymentTypeDto[] | null;
};

export enum PrequalificationStatus {
    NotSet = 'notSet',
    LinkGenerated = 'linkGenerated',
    AboutToSubmit = 'aboutToSubmit',
    Declined = 'declined',
    Approved = 'approved',
    Review = 'review',
    Signed = 'signed',
    Error = 'error',
    Invalid = 'invalid',
    Submitted = 'submitted',
    Cancelled = 'cancelled',
    Expired = 'expired',
    Prequalified = 'prequalified',
    MovedToLoanApplication = 'movedToLoanApplication',
}

export interface ApplicantDto {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    street?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

export interface RequirementsDto {
    amountRequired: boolean;
    planSelectionRequired: boolean;
    fieldsRequired?: string[] | null;
}

export interface Calculation {
    hasPromo: boolean;
    planType?: string | null;
    planNumber?: string | null;
    /** @format decimal */
    loanAmount: number;
    /** @format decimal */
    totalAmount?: number | null;
    /** @format int32 */
    amortization: number;
    paymentFrequency: PaymentFrequency;
    /** @format decimal */
    defaultRate: number;
    /** @format decimal */
    defaultMonthlyPayment: number;
    /** @format int32 */
    defaultTerms: number;
    /** @format decimal */
    promotionalRate: number;
    /** @format decimal */
    promotionalMonthlyPayment: number;
    /** @format int32 */
    promotionalTerms: number;
    eligibleForApplication: boolean;
    /** @format decimal */
    minLoanAmount: number;
    /** @format decimal */
    maxLoanAmount: number;
    description?: string | null;
    disclaimerText?: string | null;
    disclosureText?: string | null;
    /** @format decimal */
    promotionalTotalAmount?: number | null;
    displayDescription?: string | null;
    financingTerms?: string | null;
    paymentStructure: PaymentStructure;
    hasLowestPayment?: boolean | null;
    hasLowestRate?: boolean | null;
    /** @format decimal */
    suggestedMonthlyPayment?: number | null;
    /** @format int32 */
    suggestedTerms?: number | null;
}

export enum PaymentFrequency {
    NotSet = 'notSet',
    Weekly = 'weekly',
    BiWeekly = 'biWeekly',
    Monthly = 'monthly',
}

export enum PaymentStructure {
    NotSet = 'notSet',
    StandardInstallment = 'standardInstallment',
    NoInterest = 'noInterest',
    MixedInterest = 'mixedInterest',
    DeferredInterest = 'deferredInterest',
    DeferredInterestAndPrincipal = 'deferredInterestAndPrincipal',
    Promotional = 'promotional',
}

export interface SubmitPrequalResponseDto {
    prequalId?: string | null;
    externalPrequalId?: string | null;
}

export interface PrequalApplication {
    prequalId?: string | null;
    tenantId?: string | null;
    technicianId?: string | null;
    buId?: string | null;
    merchantId?: string | null;
    planNumbers?: string[] | null;
    /** @format decimal */
    requestedAmount?: number | null;
    technicianLastName?: string | null;
    technicianPhone?: string | null;
    technicianEmail?: string | null;
    fingerPrint?: string | null;
    primaryApplicant?: LoanApplicant | null;
    coApplicant?: LoanApplicant | null;
    address?: Address | null;
    source: LoanApplicationSubmitSource;
    /** The name of the ServiceTitan feature that originated this loan. */
    referrer?: string | null;
}

export interface LoanApplicant {
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    /** @format date-time */
    dateOfBirth: string;
    ssn?: string | null;
    emailAddress?: string | null;
    primaryPhone?: string | null;
    alternatePhone?: string | null;
    workPhone?: string | null;
    isMarried?: boolean | null;
    housingType: ResidenceOwnership;
    /** @format decimal */
    monthlyHousingPayment: number;
    propertyType: PropertyType;
    address?: Address | null;
    applicantId?: LoanApplicantIdDocument | null;
    employment?: ApplicantEmployment | null;
    spouseContact?: string | null;
    /** @format decimal */
    annualIncome: number;
    residenceType: ResidenceType;
    employmentStatus: EmploymentStatus;
    citizenship: Citizenship;
    isUSCitizen?: boolean | null;
    spokenLanguage: SpokenLanguage;
    signature?: string | null;
    spouse?: Spouse | null;
}

export enum ResidenceOwnership {
    NotSet = 'notSet',
    Own = 'own',
    Rent = 'rent',
    OwnWithMortgage = 'ownWithMortgage',
}

export enum PropertyType {
    NotSet = 'notSet',
    SingleFamily = 'singleFamily',
    ManufacturedHome = 'manufacturedHome',
}

export interface Address {
    street?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

export interface LoanApplicantIdDocument {
    applicantIdDocumentType: LoanApplicantIdDocumentType;
    documentId?: string | null;
    state?: string | null;
    country?: string | null;
    /** @format date-time */
    issueDate: string;
    /** @format date-time */
    expirationDate: string;
    issuerName?: string | null;
    governmentBranch?: string | null;
}

export enum LoanApplicantIdDocumentType {
    NotSet = 'notSet',
    MilitaryId = 'militaryId',
    DriversLicense = 'driversLicense',
    StateId = 'stateId',
    Passport = 'passport',
    UsaGreenCard = 'usaGreenCard',
    Visa = 'visa',
    Other = 'other',
}

export interface ApplicantEmployment {
    /** @format decimal */
    grossMonthlyIncome: number;
    employerName?: string | null;
    employerPhone?: string | null;
}

export enum ResidenceType {
    NotSet = 'notSet',
    Primary = 'primary',
    Secondary = 'secondary',
    Investment = 'investment',
}

export enum EmploymentStatus {
    NotSet = 'notSet',
    Employed = 'employed',
    Retired = 'retired',
    NotEmployed = 'notEmployed',
    Other = 'other',
}

export enum Citizenship {
    NotSet = 'notSet',
    USCitizen = 'usCitizen',
    LawfulPermanentResident = 'lawfulPermanentResident',
    Other = 'other',
}

export enum SpokenLanguage {
    NotSet = 'notSet',
    English = 'english',
    Spanish = 'spanish',
    Other = 'other',
}

export interface Spouse {
    isMarried?: boolean | null;
    firstName?: string | null;
    lastName?: string | null;
    address?: Address | null;
}

export enum LoanApplicationSubmitSource {
    Unknown = 'unknown',
    Mobile = 'mobile',
    OnlineEstimates = 'onlineEstimates',
    Estimate = 'estimate',
    Project = 'project',
    Invoice = 'invoice',
    PrequalificationLink = 'prequalificationLink',
    Imported = 'imported',
}

export interface ExternalPrequalificationDetailsDto {
    type: ExternalPrequalificationType;
    redirectUrl?: string | null;
}

export enum ExternalPrequalificationType {
    Redirect = 'redirect',
    Email = 'email',
}

export interface StartExternalPrequalificationRequest {
    prequalificationId?: string | null;
    /** @format decimal */
    requestedAmount: number;
    planNumber?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    state?: string | null;
    address?: Address | null;
    technicianEmail?: string | null;
    technicianId?: string | null;
    /** General provider name (e.g., "BuyFin") - used when ProviderName is "General" */
    generalProviderName?: string | null;
    deliveryMethod: DeliveryMethod;
    /**
     * Optional cached prequalification object. When set, the handler will use this instead of
     * reading from the database. This is used internally by StartExternalPrequalWithoutLinkHandler
     * to avoid race conditions with MongoDB replication lag.
     * WARNING: This property must NOT be mapped from API requests - it is for internal use only.
     */
    cachedPrequalification?: Prequalification | null;
}

export enum DeliveryMethod {
    None = 'none',
    Email = 'email',
    Text = 'text',
}

export interface Prequalification {
    id?: string | null;
    linkId?: string | null;
    linkUrl?: string | null;
    /** @format date-time */
    linkExpiration: string;
    providerName?: string | null;
    generalProviderName?: string | null;
    tenantId?: string | null;
    buId?: string | null;
    customerId?: string | null;
    jobId?: string | null;
    externalPrequalId?: string | null;
    referenceNumber?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    referrer?: string | null;
    planNumber?: string | null;
    /** @format decimal */
    requestedAmount?: number | null;
    /** @format decimal */
    approvedAmount?: number | null;
    /** @format date-time */
    expiresOn?: string | null;
    applicant?: Applicant | null;
    hasCoapplicant?: boolean | null;
    prequalifiedPlanNumbers?: string[] | null;
    status: PrequalificationStatus;
    paymentTypes?: PaymentType[] | null;
    technicianEmail?: string | null;
    technicianId?: string | null;
    deliveryMethod: DeliveryMethod2;
}

export interface Applicant {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    street?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

export interface PaymentType {
    id?: string | null;
    name?: string | null;
    method?: string | null;
    exportAsType?: string | null;
    /** @format date-time */
    modifiedOn: string;
    isHiddenFromMobile: boolean;
    autocompleteCED: boolean;
}

export enum DeliveryMethod2 {
    None = 'none',
    Email = 'email',
    Text = 'text',
}

/**
 * Request to start an external prequalification without requiring an existing prequal link.
 * This creates a new prequal and then forwards to StartExternalPrequalificationRequest.
 */
export type StartExternalPrequalWithoutLinkRequest = PrequalApplication & {
    providerName?: string | null;
    customerId?: string | null;
    jobId?: string | null;
    deliveryMethod?: DeliveryMethod;
    generalProviderName?: string | null;
};

export type Operation = OperationBase & {
    value?: any;
};

export interface OperationBase {
    path?: string | null;
    op?: string | null;
    from?: string | null;
}

export interface SubmitLoanApplicationResponseDto {
    /** The unique identifier of the Loan in Financing. */
    loanId?: string | null;
    /** The unique identifier of the loan in the external provider. */
    externalLoanId?: string | null;
}

export interface LoanApplication {
    loanId?: string | null;
    prequalId?: string | null;
    buId?: string | null;
    tenantId?: string | null;
    jobId?: string | null;
    technicianId?: string | null;
    customerId?: string | null;
    /** @format decimal */
    salesAmount: number;
    /** @format decimal */
    downPayment: number;
    /** @format decimal */
    requestedAmount: number;
    planNumber?: string | null;
    improvement?: string | null;
    address?: Address | null;
    primaryApplicant?: LoanApplicant | null;
    coApplicant?: LoanApplicant | null;
    providerName?: string | null;
    source: LoanApplicationSubmitSource;
    sourceId?: string | null;
    /** The name of the ServiceTitan feature that originated this loan. */
    referrer?: string | null;
    fingerPrint?: string | null;
    /** @format date-time */
    appliedOn: string;
    /** @format date-time */
    expiresOn?: string | null;
    /** @format decimal */
    availableCredit?: number | null;
    referenceNumber?: string | null;
    technicianLastName?: string | null;
    technicianPhone?: string | null;
    technicianEmail?: string | null;
    propertyType: PropertyType;
    /** @format decimal */
    mortgageBalance: number;
    /** @format decimal */
    mortgagePayment: number;
    disclosureToken?: string | null;
    providerParameters?: Record<string, string[]>;
    displayAccountNumber?: string | null;
    customPlan?: Plan | null;
}

export interface Plan {
    planNumber?: string | null;
    type?: string | null;
    description?: string | null;
    apr?: string | null;
    estimatedPaymentFactor?: string | null;
    /** @format int32 */
    term?: number | null;
    /** @format decimal */
    contractorFee?: number | null;
    /** @format decimal */
    promoPayment?: number | null;
    /** @format int32 */
    promoMonths?: number | null;
    /** @format decimal */
    normalPayment?: number | null;
    /** @format int32 */
    normalMonths?: number | null;
    /** @format decimal */
    minAmount?: number | null;
    /** @format decimal */
    maxAmount?: number | null;
    amortizations?: number[] | null;
    disclaimerText?: string | null;
    purchaseWindowMonths?: string | null;
    amortization?: string | null;
    paymentFrequency?: string | null;
}

export interface RefreshPrequalResponseDto {
    prequalId?: string | null;
    externalPrequalId?: string | null;
    status: PrequalificationStatus;
    prequalifiedPlanNumbers?: string[] | null;
    /** @format decimal */
    requestedAmount?: number | null;
    /** @format decimal */
    approvedAmount?: number | null;
}

export interface PreApprovalsDto {
    enabled: boolean;
    providerName?: string | null;
    merchantId?: string | null;
    planNumber?: string | null;
    defaultRepresentativeLastName?: string | null;
    defaultRepresentativeEmail?: string | null;
    defaultRepresentativePhone?: string | null;
}

/**
 * Stores a simple enable setting and the default provider for prequalifications, configured in the monolith
 * prequalifications settings screen.
 */
export interface TenantSettingsDto {
    tenantId?: string | null;
    enabled: boolean;
    defaultProviderName?: string | null;
    /** @format date-time */
    updatedAt: string;
    updatedByUserId?: string | null;
    preApprovals?: PreApprovalsDto | null;
}

export enum PreApprovalStatus {
    Unknown = 'unknown',
    Submitted = 'submitted',
    Approved = 'approved',
    Declined = 'declined',
    Indeterminate = 'indeterminate',
    Expired = 'expired',
    MovedToLoanApplication = 'movedToLoanApplication',
}

export interface DisclosureDto {
    category: string; // e.g. "General", "OptOut"
    text: string; // may contain provider HTML markup
}

export interface PreApprovalDto {
    id?: string | null;
    tenantId?: string | null;
    customerId?: string | null;
    providerName?: string | null;
    status?: PreApprovalStatus;
    /** @format decimal */
    amount?: number | null;
    /** @format date-time */
    createdAt?: string;
    /** @format date-time */
    expiresAt?: string | null;
    disclosures?: DisclosureDto[] | null;
    planNumber?: string | null;
}

export interface PreApprovalsGetPreApprovalParams {
    tenantId?: string | null;
    customerId?: string | null;
    buId?: string | null;
}

export type PreApprovalsGetPreApprovalData = PreApprovalDto;
export type PreApprovalsGetPreApprovalError = ProblemDetails;

export type UpdateTenantProviderSettingsRequest = TenantProviderSettingsDto & object;

/** Stores the provider specific settings for a tenant, configured in the monolith prequalifications settings screen. */
export interface TenantProviderSettingsDto {
    tenantId?: string | null;
    providerName?: string | null;
    defaultMerchantId?: string | null;
    /** @format date-time */
    updatedAt: string;
    updatedByUserId?: string | null;
    /** The ID of the rule from the Financing/Rules collection. */
    ruleId?: string | null;
    /**
     * An array of plan IDs associated with the rule.
     * Specific to GreenSky provider.
     */
    planNumbers?: string[] | null;
    /**
     * The default loan amount for the provider.
     * @format decimal
     */
    defaultLoanAmount?: number | null;
    /**
     * Default representative first name.
     * Specific to GreenSky provider.
     */
    defaultRepresentativeFirstName?: string | null;
    /**
     * Default representative last name.
     * Specific to GreenSky provider.
     */
    defaultRepresentativeLastName?: string | null;
    /**
     * Default representative email.
     * Specific to GreenSky and GoodLeap provider.
     */
    defaultRepresentativeEmail?: string | null;
}

export interface TokenDto {
    token?: string | null;
    prequalificationId?: string | null;
}

export interface GenerateTokenRequest {
    linkId?: string | null;
}

export type LoadTestCleanupLoadTestDataData = any;

export type MetricsExportMetricsAsInSampleData = any;

export type MetricsExportMetricsAsInDocsData = any;

export type StatusGetData = StatusResponse;

export type StatusMetricsData = any;

export type FinancingConnectionTestTestConnectionData = any;

export interface CustomerTagsGetCustomerTagsParams {
    tenantId?: string | null;
    customerId?: string | null;
}

export type CustomerTagsGetCustomerTagsData = CustomerTagsResponseDto[];

export type CustomerTagsGetCustomerTagsError = ProblemDetails;

export type EmbedConfigCreateOrUpdateData = EmbedConfigResponseDto;

export type EmbedConfigCreateOrUpdateError = ProblemDetails;

export type EmbedConfigGetData = EmbedConfigResponseDto;

export type EmbedConfigGetError = ProblemDetails;

export type LinkGenerateData = PrequalificationLinkDto;

export type LinkGenerateError = ProblemDetails;

export type LinkGenerateBulkData = BulkPrequalificationLinksResponseDto;

export type LinkGenerateBulkError = ProblemDetails;

export type LinkGetInitialDataData = InitialDataDto;

export type LinkGetInitialDataError = ProblemDetails;

export interface PrequalificationsSearchPrequalificationsParams {
    TenantId?: string | null;
    BuId?: string | null;
    CustomerId?: string | null;
    JobId?: string | null;
    ProviderName?: string | null;
    ExternalPrequalId?: string | null;
    ReferenceNumber?: string | null;
    OnlyNonExpired: boolean;
    /**
     * Lower bound on updatedAt field (inclusive).
     * @format date-time
     */
    UpdatedAfter?: string | null;
    Status?: PrequalificationStatus[] | null;
    /** @format int32 */
    Take?: number | null;
    /** @format int32 */
    Skip?: number | null;
    /**
     * Optional business unit ID used for compatibility filtering. When provided, only returns
     * prequalifications from providers whose prequal merchant ID matches the merchant ID
     * associated with this business unit.
     */
    CompatibleWithBuId?: string | null;
}

export type PrequalificationsSearchPrequalificationsData = SearchPrequalificationsResponseDto;

export type PrequalificationsSearchPrequalificationsError = ProblemDetails;

export interface PrequalificationsGetActivePrequalificationsParams {
    /** The tenant ID */
    tenantId?: string | null;
    /** The customer ID */
    customerId?: string | null;
    /** The business unit ID */
    buId?: string | null;
}

export type PrequalificationsGetActivePrequalificationsData = PrequalificationDto[];

export type PrequalificationsGetActivePrequalificationsError = ErrorInfo[] | ProblemDetails;

export type PrequalificationsGetPrequalificationData = PrequalificationDto;

export type PrequalificationsGetPrequalificationError = ProblemDetails;

export type PrequalificationsUpdatePrequalificationPayload = Operation[];

export type PrequalificationsUpdatePrequalificationData = any;

export type PrequalificationsUpdatePrequalificationError = ProblemDetails;

export type PrequalificationsGetPrequalificationRequirementsData = RequirementsDto;

export type PrequalificationsGetPrequalificationRequirementsError = ProblemDetails;

export interface PrequalificationsGetPrequalificationCalculationsParams {
    /**
     * Optional: Amount to use for calculations. If not provided, uses DefaultLoanAmount from prequal settings.
     * @format decimal
     */
    amount?: number | null;
    /** Optional: State (e.g., CA, TX). If provided, will be used to filter plans by availability. */
    state?: string | null;
    /** The prequalification ID */
    prequalificationId: string;
}

export type PrequalificationsGetPrequalificationCalculationsData = Calculation[];

export type PrequalificationsGetPrequalificationCalculationsError = ErrorInfo[] | ProblemDetails;

export interface PrequalificationsSubmitWithoutLinkParams {
    /** The financing provider name */
    providerName?: string | null;
    /** Customer ID */
    customerId?: string | null;
    /** Job ID */
    jobId?: string | null;
}

export type PrequalificationsSubmitWithoutLinkData = SubmitPrequalResponseDto;

export type PrequalificationsSubmitWithoutLinkError = ProblemDetails;

export type PrequalificationsSubmitData = SubmitPrequalResponseDto;

export type PrequalificationsSubmitError = ProblemDetails;

export type PrequalificationsStartExternalPrequalificationData = ExternalPrequalificationDetailsDto;

export type PrequalificationsStartExternalPrequalificationError = ProblemDetails;

export interface PrequalificationsStartExternalPrequalificationWithoutLinkParams {
    /** The financing provider name (e.g., "General") */
    providerName?: string | null;
    /** Customer ID */
    customerId?: string | null;
    /** Job ID */
    jobId?: string | null;
}

export type PrequalificationsStartExternalPrequalificationWithoutLinkData =
    ExternalPrequalificationDetailsDto;

export type PrequalificationsStartExternalPrequalificationWithoutLinkError = ProblemDetails;

export type PrequalificationsUpdatePrequalificationStatusData = PrequalificationStatus;

export type PrequalificationsUpdatePrequalificationStatusError = ProblemDetails;

export type PrequalificationsSubmitLoanApplicationData = SubmitLoanApplicationResponseDto;

export type PrequalificationsSubmitLoanApplicationError = ProblemDetails;

export type PrequalificationsRefreshPrequalificationData = RefreshPrequalResponseDto;

export type PrequalificationsRefreshPrequalificationError = ProblemDetails;

export type PublicLinkGenerateData = PrequalificationLinkDto;

export type PublicLinkGenerateError = ProblemDetails;

export type TenantsUpdateSettingsData = any;

export type TenantsGetSettingsData = TenantSettingsDto;

export type TenantsUpdateProviderSettingsData = any;

export type TenantsGetProviderSettingsData = TenantProviderSettingsDto;

export type TenantsEntraGetTenantSettingsData = TenantSettingsDto;

export type TenantsEntraUpdateTenantSettingsData = any;

export type TokenGenerateTokenData = TokenDto;

export interface CustomerTagsStGetCustomerTagsParams {
    tenantId?: string | null;
    customerId?: string | null;
}

export type CustomerTagsStGetCustomerTagsData = CustomerTagsResponseDto[];

export type CustomerTagsStGetCustomerTagsError = ProblemDetails;

export interface PrequalificationsStSearchPrequalificationsParams {
    TenantId?: string | null;
    BuId?: string | null;
    CustomerId?: string | null;
    JobId?: string | null;
    ProviderName?: string | null;
    ExternalPrequalId?: string | null;
    ReferenceNumber?: string | null;
    OnlyNonExpired: boolean;
    /**
     * Lower bound on updatedAt field (inclusive).
     * @format date-time
     */
    UpdatedAfter?: string | null;
    Status?: PrequalificationStatus[] | null;
    /** @format int32 */
    Take?: number | null;
    /** @format int32 */
    Skip?: number | null;
    /**
     * Optional business unit ID used for compatibility filtering. When provided, only returns
     * prequalifications from providers whose prequal merchant ID matches the merchant ID
     * associated with this business unit.
     */
    CompatibleWithBuId?: string | null;
}

export type PrequalificationsStSearchPrequalificationsData = SearchPrequalificationsResponseDto;

export type PrequalificationsStSearchPrequalificationsError = ProblemDetails;

import { inject, injectable, optional, symbolToken } from '@servicetitan/react-ioc';
import axios, { AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';
import { v4 as uuidv4 } from 'uuid';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<
    AxiosRequestConfig,
    'data' | 'params' | 'url' | 'responseType'
> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseType;
    /** request body */
    body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export enum RequestOrigin {
    Unknown = 'Unknown',
    Mobile = 'Mobile',
    Desktop = 'Desktop',
    BackgroundJob = 'BackgroundJob',
    Webhook = 'Webhook',
    Redirect = 'Redirect',
    CustomerPortal = 'CustomerPortal',
    CustomerPortal2 = 'CustomerPortal2',
    FMA = 'FMA',
    CPB = 'CPB',
}

@injectable()
export class HttpClient {
    sessionId: string;
    tenantId: string;
    tenantFriendlyName: string;
    actingUserId: string;
    requestOrigin: RequestOrigin;
    financingProvider: string = 'Unspecified';

    constructor(
        sessionId: string,
        tenantId: string,
        tenantFriendlyName: string,
        actingUserId: string,
        requestOrigin: RequestOrigin,
    ) {
        this.sessionId = sessionId;
        this.tenantId = tenantId;
        this.tenantFriendlyName = tenantFriendlyName;
        this.actingUserId = actingUserId;
        this.requestOrigin = requestOrigin;
    }

    public setFinancingProvider(provider: string) {
        this.financingProvider = provider;
    }

    protected stringifyFormItem(formItem: unknown) {
        if (typeof formItem === 'object' && formItem !== null) {
            return JSON.stringify(formItem);
        } else {
            return `${formItem}`;
        }
    }

    protected createFormData(input: Record<string, unknown>): FormData {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent: any[] = property instanceof Array ? property : [property];

            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }

            return formData;
        }, new FormData());
    }

    public request = async <T = any, _E = any>({
        secure,
        path,
        type,
        query,
        format,
        body,
        ...params
    }: FullRequestParams): Promise<AxiosResponse<T>> => {
        const responseFormat = format;

        if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
            body = this.createFormData(body as Record<string, unknown>);
        }

        if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
            body = JSON.stringify(body);
        }

        return axios.request({
            ...params,
            headers: {
                ...(params.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
                'X-ST-SessionId': this.sessionId,
                'X-ST-CorrelationId': uuidv4(),
                'X-ST-TenantId': this.tenantId,
                'X-ST-TenantFriendlyName': this.tenantFriendlyName,
                'X-ST-ActingUserId': this.actingUserId,
                'X-ST-FIN-Origin': this.requestOrigin,
                'X-ST-FIN-Provider': this.financingProvider,
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
            paramsSerializer: { indexes: null },
        });
    };
}

export const SESSION_ID_PrequalsApi = symbolToken<string>('SESSION_ID', false);
export const TENANT_ID_PrequalsApi = symbolToken<string>('TENANT_ID', false);
export const TENANT_FRIENDLY_NAME_PrequalsApi = symbolToken<string>('TENANT_FRIENDLY_NAME', false);
export const ACTING_USER_ID_PrequalsApi = symbolToken<string>('ACTING_USER_ID', false);
export const REQUEST_ORIGIN_PrequalsApi = symbolToken<string>('REQUEST_ORIGIN', false);

export const BASE_URL_TOKEN_PrequalsApi = symbolToken<string>('BASE_URL_TOKEN', false);

/**
 * @title Financing prequalifications microservice
 * @version v1
 * @baseUrl http://localhost:22345
 */
@injectable()
export class PrequalsApi extends HttpClient {
    constructor(
        @inject(SESSION_ID_PrequalsApi) @optional() sessionId: string,
        @inject(TENANT_ID_PrequalsApi) @optional() tenantId: string,
        @inject(TENANT_FRIENDLY_NAME_PrequalsApi) @optional() tenantFriendlyName: string,
        @inject(ACTING_USER_ID_PrequalsApi) @optional() actingUserId: string,
        @inject(REQUEST_ORIGIN_PrequalsApi) @optional() requestOrigin: RequestOrigin,
        @inject(BASE_URL_TOKEN_PrequalsApi) @optional() private readonly baseUrl = '',
    ) {
        super(sessionId, tenantId, tenantFriendlyName, actingUserId, requestOrigin);
    }

    public setFinancingProvider(provider: string): void {
        super.setFinancingProvider(provider);
    }

    /**
     * No description
     *
     * @tags LoadTest
     * @name LoadTestCleanupLoadTestData
     * @summary Cleans up data a load test. Throws 404 in non-load test services.
     * @request POST:/LoadTest/{loadTestId}/cleanup
     * @secure
     */
    loadTestCleanupLoadTestData = (loadTestId: string, params: RequestParams = {}) =>
        this.request<LoadTestCleanupLoadTestDataData, any>({
            path: `/LoadTest/${loadTestId}/cleanup`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Metrics
     * @name MetricsExportMetricsAsInSample
     * @request GET:/metrics/-exported
     * @secure
     */
    metricsExportMetricsAsInSample = (params: RequestParams = {}) =>
        this.request<MetricsExportMetricsAsInSampleData, any>({
            path: `/metrics/-exported`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Metrics
     * @name MetricsExportMetricsAsInDocs
     * @request GET:/metrics
     * @secure
     */
    metricsExportMetricsAsInDocs = (params: RequestParams = {}) =>
        this.request<MetricsExportMetricsAsInDocsData, any>({
            path: `/metrics`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Status
     * @name StatusGet
     * @summary An easy way to run health checks
     * @request GET:/Status
     * @secure
     */
    statusGet = (params: RequestParams = {}) =>
        this.request<StatusGetData, void>({
            path: `/Status`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Status
     * @name StatusMetrics
     * @request GET:/Status/metrics
     * @secure
     */
    statusMetrics = (params: RequestParams = {}) =>
        this.request<StatusMetricsData, any>({
            path: `/Status/metrics`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags FinancingConnectionTest
     * @name FinancingConnectionTestTestConnection
     * @summary Test connection to Financing service by retrieving available providers.
     * @request GET:/v1/financing-connection-test
     * @secure
     */
    financingConnectionTestTestConnection = (params: RequestParams = {}) =>
        this.request<FinancingConnectionTestTestConnectionData, any>({
            path: `/v1/financing-connection-test`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags CustomerTags
     * @name CustomerTagsGetCustomerTags
     * @summary Get prequalification-related tags for a customer within a specific tenant.
     * @request GET:/v1/customerTags
     * @secure
     */
    customerTagsGetCustomerTags = (
        query: CustomerTagsGetCustomerTagsParams,
        params: RequestParams = {},
    ) =>
        this.request<CustomerTagsGetCustomerTagsData, CustomerTagsGetCustomerTagsError>({
            path: `/v1/customerTags`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
 * No description
 *
 * @tags EmbedConfig
 * @name EmbedConfigCreateOrUpdate
 * @summary Create or update embed widget configuration for a tenant.
Returns the embed code snippet to include on the partner's website.
 * @request PUT:/v1/tenants/{tenantId}/embed-config
 * @secure
 */
    embedConfigCreateOrUpdate = (
        tenantId: string,
        data: CreateEmbedConfigRequestDto,
        params: RequestParams = {},
    ) =>
        this.request<EmbedConfigCreateOrUpdateData, EmbedConfigCreateOrUpdateError>({
            path: `/v1/tenants/${tenantId}/embed-config`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags EmbedConfig
     * @name EmbedConfigGet
     * @summary Get embed widget configuration for a tenant.
     * @request GET:/v1/tenants/{tenantId}/embed-config
     * @secure
     */
    embedConfigGet = (tenantId: string, params: RequestParams = {}) =>
        this.request<EmbedConfigGetData, EmbedConfigGetError>({
            path: `/v1/tenants/${tenantId}/embed-config`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Link
     * @name LinkGenerate
     * @request POST:/v1/Link
     * @secure
     */
    linkGenerate = (data: CreatePrequalificationLinkRequestDto, params: RequestParams = {}) =>
        this.request<LinkGenerateData, LinkGenerateError>({
            path: `/v1/Link`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Link
     * @name LinkGenerateBulk
     * @request POST:/v1/Link/bulk
     * @secure
     */
    linkGenerateBulk = (
        data: CreateBulkPrequalificationLinksRequestDto,
        params: RequestParams = {},
    ) =>
        this.request<LinkGenerateBulkData, LinkGenerateBulkError>({
            path: `/v1/Link/bulk`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Link
     * @name LinkGetInitialData
     * @request GET:/v1/Link/{linkId}/initialData
     * @secure
     */
    linkGetInitialData = (linkId: string, params: RequestParams = {}) =>
        this.request<LinkGetInitialDataData, LinkGetInitialDataError>({
            path: `/v1/Link/${linkId}/initialData`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsSearchPrequalifications
     * @summary Search for prequalifications based on the provided search criteria
     * @request GET:/v1/prequals
     * @secure
     */
    prequalificationsSearchPrequalifications = (
        query: PrequalificationsSearchPrequalificationsParams,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsSearchPrequalificationsData,
            PrequalificationsSearchPrequalificationsError
        >({
            path: `/v1/prequals`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * @tags PreApprovals
     * @name PreApprovalsGetPreApproval
     * @summary Get the latest non-expired pre-approval for a customer
     * @request GET:/v1/preapprovals
     * @secure
     */
    preApprovalsGetPreApproval = (
        query: PreApprovalsGetPreApprovalParams,
        params: RequestParams = {},
    ) =>
        this.request<PreApprovalsGetPreApprovalData, PreApprovalsGetPreApprovalError>({
            path: `/v1/preapprovals`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsGetActivePrequalifications
     * @summary Get active and recently declined prequalifications for a customer
     * @request GET:/v1/prequals/active
     * @secure
     */
    prequalificationsGetActivePrequalifications = (
        query: PrequalificationsGetActivePrequalificationsParams,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsGetActivePrequalificationsData,
            PrequalificationsGetActivePrequalificationsError
        >({
            path: `/v1/prequals/active`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsGetPrequalification
     * @summary Get a single prequalification by ID
     * @request GET:/v1/prequals/{prequalificationId}
     * @secure
     */
    prequalificationsGetPrequalification = (
        prequalificationId: string,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsGetPrequalificationData,
            PrequalificationsGetPrequalificationError
        >({
            path: `/v1/prequals/${prequalificationId}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsUpdatePrequalification
     * @summary Update a prequalification
     * @request PATCH:/v1/prequals/{prequalificationId}
     * @secure
     */
    prequalificationsUpdatePrequalification = (
        prequalificationId: string,
        data: PrequalificationsUpdatePrequalificationPayload,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsUpdatePrequalificationData,
            PrequalificationsUpdatePrequalificationError
        >({
            path: `/v1/prequals/${prequalificationId}`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsGetPrequalificationRequirements
     * @summary Get the requirements for starting a prequalification
     * @request GET:/v1/prequals/{prequalificationId}/requirements
     * @secure
     */
    prequalificationsGetPrequalificationRequirements = (
        prequalificationId: string,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsGetPrequalificationRequirementsData,
            PrequalificationsGetPrequalificationRequirementsError
        >({
            path: `/v1/prequals/${prequalificationId}/requirements`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsGetPrequalificationCalculations
     * @summary Get calculations for a prequalification
     * @request GET:/v1/prequals/{prequalificationId}/calculations
     * @secure
     */
    prequalificationsGetPrequalificationCalculations = (
        { prequalificationId, ...query }: PrequalificationsGetPrequalificationCalculationsParams,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsGetPrequalificationCalculationsData,
            PrequalificationsGetPrequalificationCalculationsError
        >({
            path: `/v1/prequals/${prequalificationId}/calculations`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsSubmitWithoutLink
     * @summary Submit a prequalification application without having a link. This allows a prequalification to be started without having a link.
     * @request POST:/v1/prequals/submit
     * @secure
     */
    prequalificationsSubmitWithoutLink = (
        query: PrequalificationsSubmitWithoutLinkParams,
        data: PrequalApplication,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsSubmitWithoutLinkData,
            PrequalificationsSubmitWithoutLinkError
        >({
            path: `/v1/prequals/submit`,
            method: 'POST',
            baseURL: this.baseUrl,
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsSubmit
     * @summary Submit a prequalification application.
     * @request POST:/v1/prequals/{prequalificationId}/submit
     * @secure
     */
    prequalificationsSubmit = (
        prequalificationId: string,
        data: PrequalApplication,
        params: RequestParams = {},
    ) =>
        this.request<PrequalificationsSubmitData, PrequalificationsSubmitError>({
            path: `/v1/prequals/${prequalificationId}/submit`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsStartExternalPrequalification
     * @summary Start an external prequalification for an existing prequalification.
     * @request POST:/v1/prequals/{prequalificationId}/external
     * @secure
     */
    prequalificationsStartExternalPrequalification = (
        prequalificationId: string,
        data: StartExternalPrequalificationRequest,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsStartExternalPrequalificationData,
            PrequalificationsStartExternalPrequalificationError
        >({
            path: `/v1/prequals/${prequalificationId}/external`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
 * No description
 *
 * @tags Prequalifications
 * @name PrequalificationsStartExternalPrequalificationWithoutLink
 * @summary Start an external prequalification without having an existing prequal link.
This creates a new prequalification and then starts the external prequalification process.
Used for providers like General that use external application flows.
 * @request POST:/v1/prequals/external
 * @secure
 */
    prequalificationsStartExternalPrequalificationWithoutLink = (
        query: PrequalificationsStartExternalPrequalificationWithoutLinkParams,
        data: StartExternalPrequalWithoutLinkRequest,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsStartExternalPrequalificationWithoutLinkData,
            PrequalificationsStartExternalPrequalificationWithoutLinkError
        >({
            path: `/v1/prequals/external`,
            method: 'POST',
            baseURL: this.baseUrl,
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsUpdatePrequalificationStatus
     * @summary Get the status of the prequalification. This will query the provider to get the status of the prequalification if needed.
     * @request POST:/v1/prequals/{prequalificationId}/status
     * @secure
     */
    prequalificationsUpdatePrequalificationStatus = (
        prequalificationId: string,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsUpdatePrequalificationStatusData,
            PrequalificationsUpdatePrequalificationStatusError
        >({
            path: `/v1/prequals/${prequalificationId}/status`,
            method: 'POST',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsSubmitLoanApplication
     * @summary Submit a full loan application from the prequalification
     * @request POST:/v1/prequals/submitLoanApplication
     * @secure
     */
    prequalificationsSubmitLoanApplication = (data: LoanApplication, params: RequestParams = {}) =>
        this.request<
            PrequalificationsSubmitLoanApplicationData,
            PrequalificationsSubmitLoanApplicationError
        >({
            path: `/v1/prequals/submitLoanApplication`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Prequalifications
     * @name PrequalificationsRefreshPrequalification
     * @summary Refresh a prequalification by reloading status and details from the provider.
     * @request PUT:/v1/prequals/{prequalificationId}/refresh
     * @secure
     */
    prequalificationsRefreshPrequalification = (
        prequalificationId: string,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsRefreshPrequalificationData,
            PrequalificationsRefreshPrequalificationError
        >({
            path: `/v1/prequals/${prequalificationId}/refresh`,
            method: 'PUT',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
 * No description
 *
 * @tags PublicLink
 * @name PublicLinkGenerate
 * @summary Generate a prequalification link using API key authentication.
This endpoint is intended for frontend widgets embedded on partner websites.
 * @request POST:/v1/public/link
 * @secure
 */
    publicLinkGenerate = (data: CreatePrequalificationLinkRequestDto, params: RequestParams = {}) =>
        this.request<PublicLinkGenerateData, PublicLinkGenerateError>({
            path: `/v1/public/link`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsUpdateSettings
     * @request PUT:/v1/Tenants/{tenantId}/settings
     * @secure
     */
    tenantsUpdateSettings = (
        tenantId: string,
        data: TenantSettingsDto,
        params: RequestParams = {},
    ) =>
        this.request<TenantsUpdateSettingsData, any>({
            path: `/v1/Tenants/${tenantId}/settings`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetSettings
     * @request GET:/v1/Tenants/{tenantId}/settings
     * @secure
     */
    tenantsGetSettings = (tenantId: string, params: RequestParams = {}) =>
        this.request<TenantsGetSettingsData, void>({
            path: `/v1/Tenants/${tenantId}/settings`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsUpdateProviderSettings
     * @request PUT:/v1/Tenants/{tenantId}/provider/{providerName}
     * @secure
     */
    tenantsUpdateProviderSettings = (
        tenantId: string,
        providerName: string,
        data: UpdateTenantProviderSettingsRequest,
        params: RequestParams = {},
    ) =>
        this.request<TenantsUpdateProviderSettingsData, any>({
            path: `/v1/Tenants/${tenantId}/provider/${providerName}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Tenants
     * @name TenantsGetProviderSettings
     * @request GET:/v1/Tenants/{tenantId}/provider/{providerName}
     * @secure
     */
    tenantsGetProviderSettings = (
        tenantId: string,
        providerName: string,
        params: RequestParams = {},
    ) =>
        this.request<TenantsGetProviderSettingsData, void>({
            path: `/v1/Tenants/${tenantId}/provider/${providerName}`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags TenantsEntra
     * @name TenantsEntraGetTenantSettings
     * @request GET:/v1/TenantsEntra/{tenantId}/settings
     * @secure
     */
    tenantsEntraGetTenantSettings = (tenantId: string, params: RequestParams = {}) =>
        this.request<TenantsEntraGetTenantSettingsData, void>({
            path: `/v1/TenantsEntra/${tenantId}/settings`,
            method: 'GET',
            baseURL: this.baseUrl,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags TenantsEntra
     * @name TenantsEntraUpdateTenantSettings
     * @request PUT:/v1/TenantsEntra/{tenantId}/settings
     * @secure
     */
    tenantsEntraUpdateTenantSettings = (
        tenantId: string,
        data: TenantSettingsDto,
        params: RequestParams = {},
    ) =>
        this.request<TenantsEntraUpdateTenantSettingsData, void>({
            path: `/v1/TenantsEntra/${tenantId}/settings`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Token
     * @name TokenGenerateToken
     * @request POST:/v1/Token
     * @secure
     */
    tokenGenerateToken = (data: GenerateTokenRequest, params: RequestParams = {}) =>
        this.request<TokenGenerateTokenData, any>({
            path: `/v1/Token`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags CustomerTagsSt
     * @name CustomerTagsStGetCustomerTags
     * @summary Get prequalification-related tags for a customer within a specific tenant.
     * @request GET:/st/v1/customerTags
     * @secure
     */
    customerTagsStGetCustomerTags = (
        query: CustomerTagsStGetCustomerTagsParams,
        params: RequestParams = {},
    ) =>
        this.request<CustomerTagsStGetCustomerTagsData, CustomerTagsStGetCustomerTagsError>({
            path: `/st/v1/customerTags`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });

    /**
     * No description
     *
     * @tags PrequalificationsSt
     * @name PrequalificationsStSearchPrequalifications
     * @summary Search for prequalifications based on the provided search criteria
     * @request GET:/st/v1/prequals
     * @secure
     */
    prequalificationsStSearchPrequalifications = (
        query: PrequalificationsStSearchPrequalificationsParams,
        params: RequestParams = {},
    ) =>
        this.request<
            PrequalificationsStSearchPrequalificationsData,
            PrequalificationsStSearchPrequalificationsError
        >({
            path: `/st/v1/prequals`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            secure: true,
            ...params,
        });
}
